<template>
  <b-modal
    v-model="localIsVisible"
    hide-footer
    @cancel="onCancel"
  >
    <h3 class="modal-title">Cambiar Fecha de Terapia</h3>

    <div class="my-2">
      <label for="fecha-programada">Seleccione la nueva fecha:</label>
      <input
        id="fecha-programada"
        type="datetime-local"
        v-model="newDateTerapia"
        class="form-control"
      />
    </div>

    <b-row class="my-2 mt-3">

      <b-col class="d-flex justify-content-end">
        <b-button 
          variant="secondary" 
          @click="onCancel"
          class="mr-2"
        > 
          Cancelar 
        </b-button>

        <b-button 
          variant="primary" 
          @click="changeDateTerapia( idTerapia, newDateTerapia)"
        > 
          Cambiar fecha 
        </b-button>
      </b-col>

    </b-row>
  </b-modal>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";

export default {

  name: "ModalChangeDateTerapia",

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    
    idTerapia:{
      type: String,
      default: null
    }
    
  },

  data() {
    return {
      localIsVisible: false,
      fechaProgramadaSeleccionada: null,

      newDateTerapia: null,

    };
  },

  methods:{

    onCancel() {
      this.localIsVisible = false
    },

    async changeDateTerapia(idSolicitudTerapia, fechaProgramada) {
      const fechaActual = new Date();
      const fechaActualFormateada = fechaActual.toISOString().split("T")[0];
      const fechaProgramadaFormateada = new Date(fechaProgramada)
        .toISOString()
        .split("T")[0];
      
      // if (fechaProgramadaFormateada < fechaActualFormateada) {
      //   this.$swal({
      //     icon: "error",
      //     title: "Error",
      //     text: "La fecha no puede ser menor que la fecha actual.",
      //   });
      //   return;
      // }

      const confirmation = await this.$swal({
        title: "¿Estás seguro de actualizar la fecha?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "Cancelar",
      });

      if (confirmation.isConfirmed) {
        const mutation = `
          mutation ActualizarFechaTerapia($idSolicitudTerapia: String!, $fechaProgramada: DateTime!) {
            actualizarFechaProgramadaTerapia(idSolicitudTerapia: $idSolicitudTerapia, fechaProgramada: $fechaProgramada) {
              solicitudTerapia {
                id
                fechaProgramada
              }
            }
          }
        `;

        const variables = {
          idSolicitudTerapia: idSolicitudTerapia,
          fechaProgramada: fechaProgramada.toString(),
        };

        try {
          const response = await axios.post(rutas.axios + "api", {
            query: mutation,
            variables: variables,
          });

          if (response.data.errors) {
            // Error en el servidor backend
            this.$swal({
              icon: "error",
              title: "Error",
              text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
            });
          } else {
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: "La fecha se actualizó correctamente.",
            });

            this.$router.go({ name: "consultar_terapia_programada" });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Hubo un error al actualizar la fecha. Por favor, inténtalo de nuevo.",
          });
        }
      }
    },
  },

  watch: {
    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    }
  }

}
</script>
